"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = assertNever;
function assertNever(x, message) {
    throw new Error(`${message}`);
}
